export const getAuthHeader = () => {
  const apikey = localStorage.getItem("ak");
  if (!apikey) return {};
  return {
    Authorization: `Basic ${btoa(`placeholder:${apikey}`)}`,
  } as Record<string, string>;
};

export const fetchWithAuth = async (url: string, options: RequestInit = {}) => {
  const headers: HeadersInit = {
    ...getAuthHeader(),
    ...(options.headers as Record<string, string>),
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  return response;
};

export const handleAPIResponse = async <T>(response: Response): Promise<T> => {
  const data = await response.json();
  if (data.err) {
    throw new Error(data.errdata || "API Error");
  }
  return data.message;
};
